"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebFontStack = exports.WebFontIcon = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var WebFontIcon = function WebFontIcon(_ref) {
  var family = _ref.family,
      icon = _ref.icon,
      spin = _ref.spin,
      className = _ref.className;
  var families = {
    regular: 'far',
    solid: 'fas',
    light: 'fal',
    brand: 'fab'
  };
  var classes = (0, _classnames.default)('fe-icon', families[family], "fa-".concat(icon), {
    'fa-spin': spin
  }, className);
  return _react.default.createElement("i", {
    className: classes
  });
};

exports.WebFontIcon = WebFontIcon;
WebFontIcon.propTypes = {
  /** The icon name */
  icon: _propTypes.default.string.isRequired,

  /** The Icon family. Can be regular, solid, light, or brand */
  family: _propTypes.default.oneOf(['regular', 'solid', 'light', 'brand']),

  /** Whether or not the icon should spin */
  spin: _propTypes.default.bool,

  /** Additional classname to apply to the icon */
  className: _propTypes.default.string
};

var WebFontStack = function WebFontStack(_ref2) {
  var className = _ref2.className,
      stackProps = _objectWithoutProperties(_ref2, ["className"]);

  var classNames = (0, _classnames.default)('fa-stack', className);
  return _react.default.createElement("div", _extends({
    className: classNames
  }, stackProps));
};

exports.WebFontStack = WebFontStack;

var FontAwesomeContext = _react.default.createContext({
  Icon: WebFontIcon,
  Stack: WebFontStack
});

var _default = FontAwesomeContext;
exports.default = _default;